import React from 'react';
import Legal from './Legal';

const link = "https://docs.google.com/document/d/e/2PACX-1vQJF4n0oXM0E730cQAJoBQC2sN9SF39GUua-dujrR5xY-leF_AQBHayS3V4mslF06_PrgJBne0ylcgg/pub?embedded=true";

export default () => {
  return (<Legal title="Terms of Service" link={link} />);
}


// WEBPACK FOOTER //
// ./src/entries/Legal/Terms.js